// +----------------------------------------------------------------------
// | ThisAdmin [ ThisAdmin赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2022 https://www.thisadmin.cn All rights reserved.
// +----------------------------------------------------------------------
// | Licensed ThisAdmin并不是自由软件，未经许可不能去掉ThisAdmin相关版权
// +----------------------------------------------------------------------
// | Author: ThisAdmin Team   Email: thisteam@qq.com
// +----------------------------------------------------------------------

//路由对象
let routeOptions = [
  {path: '/',name: 'index', url: '/index/index', meta: {title: '首页-打造洗衣家政解决方案和行业应用，助力企业发展 '}},
  {path: '/solution',name: 'solution', url: '/index/solution', meta: {title: '解决方案库-打造洗衣家政解决方案和行业应用，助力企业发展 '}},
  {path: '/standard',name: 'standard', url: '/index/standard', meta: {title: '标品软件-打造洗衣家政解决方案和行业应用，助力企业发展 '}},
  {path: '/report',name: 'report', url: '/index/report', meta: {title: '行研报告-打造洗衣家政解决方案和行业应用，助力企业发展 '}},
  {path: '/case',name: 'case', url: '/index/case', meta: {title: '落地案例-打造洗衣家政解决方案和行业应用，助力企业发展 '}},
  {path: '/develop',name: 'develop', url: '/index/develop', meta: {title: '共研共创-打造洗衣家政解决方案和行业应用，助力企业发展 '}},
  {path: 'login',name: 'login', url: '/login', meta: {title: '账号登录-打造洗衣家政解决方案和行业应用，助力企业发展 '}},
  {path: 'detail/:id',name: 'detail', url: '/index/detail', meta: {title: '作品详情-打造洗衣家政解决方案和行业应用，助力企业发展 '}},
  {path: 'utterer/:uid',name: 'utterer', url: '/index/utterer', meta: {title: '作者主页-打造洗衣家政解决方案和行业应用，助力企业发展 '}},
  {path: 'page/:ident',name: 'page', url: '/index/page', meta: {title: '帮助文档，平台协议-打造洗衣家政解决方案和行业应用，助力企业发展 '}},
  {path: '/authentication',name: 'authentication', url: '/authentication/index', meta: {title: '认证中心'}}
]
//循环绑定路由
const children = routeOptions.map(route => {
  return {
    ...route,
    component: () => import(/* webpackChunkName: "[request]" */ '@/views' + route.url + '.vue')
  }
})

export default {
  path: '/',
  name: 'front',
  meta: {title: '咋办解决方案'},
  component: () => import('@/layout/front.vue'),
  children: children
};